var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "love",
    transform: "translate(-4466.057 -2167.377)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4466.057 2167.377)",
    fill: "#e05e6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M4484.2,2195.37l8.023-6.489a5.958,5.958,0,0,0,1.952-2.8c1.473-4.619-2.717-9.562-7.675-7.622a2.3,2.3,0,0,1-4.6,0c-4.959-1.94-9.148,3-7.675,7.622a5.948,5.948,0,0,0,1.952,2.8Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.0f76e7d766d7b498e4d79403b2306e38.svg";
export { ForwardRef as ReactComponent };